import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("header", { class: "py-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "max-w-7xl 2xl:max-w-screen-2xl mx-auto" })
], -1)
const _hoisted_2 = { id: "management" }
const _hoisted_3 = { class: "bg-white py-8 lg:py-10 rounded-md shadow-sm mx-auto max-w-7xl" }
const _hoisted_4 = {
  key: 1,
  class: "mx-auto grid grid-cols-1 gap-14 px-8 xl:gap-y-20 xl:px-10 xl:grid-cols-3 items-start"
}
const _hoisted_5 = { class: "mx-auto xl:max-w-2xl xl:mx-0 xl:sticky top-5" }
const _hoisted_6 = { class: "md:flex md:items-start xl:block" }
const _hoisted_7 = { class: "xl:col-span-2 spacy-y-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_OriginatorName = _resolveComponent("OriginatorName")!
  const _component_OriginatorHighlight = _resolveComponent("OriginatorHighlight")!
  const _component_OriginatorCtaWithOptions = _resolveComponent("OriginatorCtaWithOptions")!
  const _component_JanoverCta = _resolveComponent("JanoverCta")!
  const _component_OriginatorPreferences = _resolveComponent("OriginatorPreferences")!
  const _component_OriginatorActivity = _resolveComponent("OriginatorActivity")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.originator)
          ? (_openBlock(), _createBlock(_component_BaseSpinner, {
              key: 0,
              class: "h-80"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_OriginatorName, {
                  class: "mb-6",
                  originator: _ctx.originator,
                  lender: _ctx.lender
                }, null, 8, ["originator", "lender"]),
                _createVNode(_component_OriginatorHighlight, {
                  "soft-quotes": _ctx.softQuotes,
                  originator: _ctx.originator
                }, null, 8, ["soft-quotes", "originator"]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_OriginatorCtaWithOptions, {
                    class: "mt-10 md:pr-6 xl:pr-0",
                    originator: _ctx.originator
                  }, null, 8, ["originator"]),
                  _createVNode(_component_JanoverCta, { class: "mt-10 md:pr-6 xl:pr-0" })
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_OriginatorPreferences, { originator: _ctx.originator }, null, 8, ["originator"]),
                _createVNode(_component_OriginatorActivity, { deals: _ctx.deals }, null, 8, ["deals"])
              ])
            ]))
      ])
    ])
  ], 64))
}